'use client';
import { cn } from '@/lib/utils';

import { IconButton } from '@/components/atoms/IconButton';

import arrowLeftSrc from '~/icons/arrow-left.svg';
import arrowRightSrc from '~/icons/arrow-right.svg';

import { SvgIcon } from '@/components/SvgIcon';
type TestimonialActionsProps = {
  handlePrevious: () => void;
  handleNext: () => void;
  isPreviousDisabled: boolean;
  isNextDisabled: boolean;
};

const arrowClassName = 'h-6 w-6 text-base-white';

export const TestimonialActions = ({
  handlePrevious,
  handleNext,
  isPreviousDisabled,
  isNextDisabled,
}: TestimonialActionsProps) => {
  return (
    <div className='flex justify-end gap-x-4 w-full'>
      <IconButton
        onClick={handlePrevious}
        variant='filled'
        color='primary'
        size='l'
        classNames={{ root: 'rounded-full z-10' }}
        disabled={isPreviousDisabled}
        aria-label='Previous testimonial'
      >
        <SvgIcon src={arrowLeftSrc}
          className={cn(arrowClassName, isPreviousDisabled && 'text-gray-400')}
        />
      </IconButton>
      <IconButton
        onClick={handleNext}
        variant='filled'
        color='primary'
        size='l'
        classNames={{ root: 'rounded-full z-10' }}
        disabled={isNextDisabled}
        aria-label='Next testimonial'
      >
        <SvgIcon src={arrowRightSrc}
          className={cn(arrowClassName, isNextDisabled && 'text-gray-400')}
        />
      </IconButton>
    </div>
  );
};
